// import {
//   Injectable
// } from '@angular/core';
// import {
//   HttpEvent,
//   HttpInterceptor,
//   HttpHandler,
//   HttpRequest,
//   HttpResponse,
//   HttpErrorResponse
// } from '@angular/common/http';
// import { NavigationStart, Router } from '@angular/router';
// import {
//   Observable,
//   throwError,
//   fromEvent,
//   of,
//   timer,
//   Subject,
//   EMPTY
// } from 'rxjs';
// import {
//   retryWhen,
//   switchMap,
//   mapTo,
//   catchError,
//   tap,
//   delayWhen,
//   filter,
//   scan,
//   takeUntil
// } from 'rxjs/operators';
// import {
//   MainService
// } from '../main/main.service';
// import {
//   LoaderService
// } from './loader.service';
// import {
//   GlobalFilterService
// } from '../shared/global-filter.service';

// @Injectable({
//   providedIn: 'root'
// })
// export class InterceptorService implements HttpInterceptor {
//   private onlineChanges$ = fromEvent(window, 'online').pipe(mapTo(true));
//   private cache_data: any = {};
//   private requestCancelMap: Map<string, Subject<void>> = new Map();
//   private readonly routeCancelExemptEndpoints = ['auth_check_login', 'get_settings', 'access_token_login', 'get_can_finance_status'];
//   private activeRequestCount = 0;

//   constructor(
//     private mainService: MainService,
//     private loaderService: LoaderService,
//     private globalFilter: GlobalFilterService,
//     private router: Router
//   ) {
//     this.router.events
//       .pipe(filter((event) => event instanceof NavigationStart))
//       .subscribe(() => this.cancelPendingRequestsOnNavigation());
//   }

//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     var headers = req.headers;

//     const googTrans = this.mainService.gt_get_cookie('googtrans');
//     const language = googTrans ? googTrans.split('/').pop() : null;

//     const clckData = this.getClck();
//     const userProfile = this.getUserProfile();
//     const clientVersion = localStorage.getItem('client_version');

//     const isFinanceStatusRequest = req.url.indexOf('get_can_finance_status') !== -1;
//     const shouldSkipFinanceLoader = this.mainService.newfinanceUi && isFinanceStatusRequest;
//     const showLoader = req.body && !req.body.hideLoader && !shouldSkipFinanceLoader && !req.url.includes('upload_claim_doc') && !req.url.includes('upload_more_doc');
//     if (showLoader) {
//       this.showLoader();
//     }

//     // Cache shortcut
//     if (req.url.indexOf('get_can_finance_status') !== -1 && req.body && req.body.doctor_id) {
//       const cache = this.cache_data[req.body.doctor_id];
//       if (cache) {
//         return of(new HttpResponse({ status: 200, body: cache.data }));
//       }
//     }

//     if (req.method.toLowerCase() === 'post') {
//       headers = headers.set('client_url', window.location.href);
//     }

//     const userData = this.globalFilter.getFilterObj('location');
//     if (userData && userProfile) {
//       headers = headers.set('x-doctor-id', userProfile['doctor_id'] ? String(userProfile['doctor_id']) : '');
//       if (userData && userProfile['enterprise_email']) {
//         headers = headers.set('type', 'enterprise');
//       }
//       if (userProfile['role_id'] === 1) {
//         headers = headers.set('x-user-role', 'enterprise');
//       } else if (userProfile['role_id'] === 4) {
//         headers = headers.set('x-user-role', 'doctor');
//       }

//       if (userData && userData.name !== 'All' &&
//         (req.url.includes('subscription_detail') ||
//           req.url.includes('ar_v2_enterprise_dashboard') ||
//           req.url.includes('claim_listing'))) {
//         req.body['doctor_id'] = userData['id'];
//       } else if (userData && userData.name === 'All' && req.url.includes('subscription_detail')) {
//         this.onEnd();
//         return EMPTY;
//       }
//     }

//     if (clientVersion) {
//       headers = headers.set('x-client-version', clientVersion);
//     }

//     if (clckData && clckData[1]) {
//       headers = headers.set('x-clck-id', String(clckData[1]));
//     }

//     if (language) {
//       headers = headers.set('x-lan-code', language);
//     }

//     headers = headers
//       .set('X-Requested-With', 'XMLHttpRequest')
//       .set('Referrer-Policy', 'no-referrer');

//     const updatedReq = req.clone({ headers });

//     const requestKey = this.generateRequestKey(updatedReq.url,req.body?.noBody ? {} : updatedReq.body);

//     if (!this.shouldKeepRequestOnNavigation(requestKey) && this.requestCancelMap.has(requestKey)) {
//       this.requestCancelMap.get(requestKey).next && this.requestCancelMap.get(requestKey).next();
//       this.requestCancelMap.get(requestKey).complete && this.requestCancelMap.get(requestKey).complete();
//       this.decrementRequestCount();
//     }

//     const cancelSubject = new Subject<void>();
//     this.requestCancelMap.set(requestKey, cancelSubject);

//     if (showLoader) this.activeRequestCount++; // Increment for this loader-enabled request

//     return next.handle(updatedReq).pipe(
//       takeUntil(cancelSubject),
//       retryWhen(errors =>
//         errors.pipe(
//           scan((retryCount, error: any) => {
//             if (retryCount >= 3 || (error && error.status && error.status < 500)) {
//               throw error;
//             }
//             return retryCount + 1;
//           }, 0),
//           delayWhen(retryCount => timer(Math.pow(2, retryCount) * 500))
//         )
//       ),
//       tap((event) => {
//         if (event instanceof HttpResponse) {
//           if (updatedReq.url.indexOf('get_can_finance_status') !== -1 && (updatedReq.body && updatedReq.body.doctor_id)) {
//             this.cache_data[updatedReq.body.doctor_id] = {
//               timestamp: Date.now(),
//               data: event.body
//             };
//           }
//           this.requestCancelMap.delete(requestKey);
//           if (showLoader) this.decrementRequestCount();
//         }
//       }),
//       catchError((error: HttpErrorResponse) => {
//         this.requestCancelMap.delete(requestKey);
//         if (showLoader) this.decrementRequestCount();
//         return throwError(error);
//       })
//     );
//   }

//   private decrementRequestCount(): void {
//     this.activeRequestCount--;
//     if (this.activeRequestCount <= 0) {
//       this.activeRequestCount = 0;
//       this.hideLoader();
//     }
//   }

//   private cancelPendingRequestsOnNavigation(): void {
//     if (!this.requestCancelMap.size) {
//       return;
//     }
//     this.requestCancelMap.forEach((cancelSubject, requestKey) => {
//       if (this.shouldKeepRequestOnNavigation(requestKey)) {
//         return;
//       }
//       cancelSubject.next();
//       cancelSubject.complete();
//       this.requestCancelMap.delete(requestKey);
//     });
//     this.activeRequestCount = 0;
//     this.hideLoader();
//   }

//   private shouldKeepRequestOnNavigation(requestKey: string): boolean {
//     return this.routeCancelExemptEndpoints.some((endpoint) => requestKey.includes(endpoint));
//   }

//   private generateRequestKey(url: string, body: any): string {
//     const base = url.split('?')[0];
//     const sortedBody = body ? JSON.stringify(this.sortObjectKeys(body)) : '';
//     return `${base}|${sortedBody}`;
//   }

//   private sortObjectKeys(obj: any): any {
//     return Object.keys(obj || {}).sort().reduce((r, k) => (r[k] = obj[k], r), {});
//   }

//   private get isOnline(): boolean {
//     return navigator.onLine;
//   }

//     private onEnd(): void {
//     this.hideLoader();
//   }

//   private showLoader(): void {
//     this.loaderService.show();
//   }

//   private hideLoader(): void {
//     this.loaderService.hide();
//   }

//   private getUserProfile(): any {
//     try {
//       const raw = localStorage.getItem('userProfileData');
//       const parsed = raw ? JSON.parse(raw) : null;
//       return Array.isArray(parsed) ? parsed[0] : parsed;
//     } catch (e) {
//       return null;
//     }
//   }

//   private getClck(): string[] | null {
//     var decodedCookie = decodeURIComponent(document.cookie);
//     var parts = decodedCookie.split(';');
//     for (var i = 0; i < parts.length; i++) {
//       if (parts[i].indexOf('_clck') !== -1) {
//         return parts[i].split('=');
//       }
//     }
//     return null;
//   }
// }


import {
  Injectable
} from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import {
  Observable,
  throwError,
  fromEvent,
  of,
  timer,
  Subject,
  EMPTY
} from 'rxjs';
import {
  retryWhen,
  switchMap,
  mapTo,
  catchError,
  tap,
  delayWhen,
  scan,
  takeUntil
} from 'rxjs/operators';
import {
  MainService
} from '../main/main.service';
import {
  LoaderService
} from './loader.service';
import {
  GlobalFilterService
} from '../shared/global-filter.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  private onlineChanges$ = fromEvent(window, 'online').pipe(mapTo(true));
  private cache_data: any = {};
  private cacheTTL = 5 * 60 * 1000; // 5 minutes
  private requestCancelMap: Map<string, Subject<void>> = new Map();
  private activeRequestCount = 0;

  constructor(
    private mainService: MainService,
    private loaderService: LoaderService,
    private globalFilter: GlobalFilterService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    var headers = req.headers;

    const googTrans = this.mainService.gt_get_cookie('googtrans');
    const language = googTrans ? googTrans.split('/').pop() : null;

    const clckData = this.getClck();
    const userProfile = this.getUserProfile();
    const clientVersion = localStorage.getItem('client_version');

    const showLoader = req.body && !req.body.hideLoader && !req.url.includes('upload_claim_doc') && !req.url.includes('upload_more_doc') && !req.url.includes('get_terminal_financing_request');
    if (showLoader) {
      this.showLoader();
    }

    // Cache shortcut
    if (req.url.indexOf('get_can_finance_status') !== -1 && req.body && req.body.doctor_id && req.body.from_cache !== 0) {
      const cache = this.cache_data[req.body.doctor_id];
      if (cache && (Date.now() - cache.timestamp < this.cacheTTL)) {
        return of(new HttpResponse({ status: 200, body: cache.data }));
      }
    }

    if (req.method.toLowerCase() === 'post') {
      headers = headers.set('client_url', window.location.href);
    }

    const userData = this.globalFilter.getFilterObj('location');
    if (userData && userProfile) {
      headers = headers.set('x-doctor-id', userProfile['doctor_id'] ? String(userProfile['doctor_id']) : '');
      if (userData && userProfile['enterprise_email']) {
        headers = headers.set('type', 'enterprise');
      }
      if (userProfile['role_id'] === 1) {
        headers = headers.set('x-user-role', 'enterprise');
      } else if (userProfile['role_id'] === 4) {
        headers = headers.set('x-user-role', 'doctor');
      }

      if (userData && userData.name !== 'All' &&
        (req.url.includes('subscription_detail') ||
          req.url.includes('ar_v2_enterprise_dashboard') ||
          req.url.includes('claim_listing'))) {
        req.body['doctor_id'] = userData['id'];
      } else if (userData && userData.name === 'All' && req.url.includes('subscription_detail')) {
        this.onEnd();
        return EMPTY;
      }
    }

    if (clientVersion) {
      headers = headers.set('x-client-version', clientVersion);
    }

    if (clckData && clckData[1]) {
      headers = headers.set('x-clck-id', String(clckData[1]));
    }

    if (language) {
      headers = headers.set('x-lan-code', language);
    }

    headers = headers
      .set('X-Requested-With', 'XMLHttpRequest')
      .set('Referrer-Policy', 'no-referrer');

    const updatedReq = req.clone({ headers });

    const requestKey = this.generateRequestKey(updatedReq.url,req.body?.noBody ? {} : updatedReq.body);

    if (this.requestCancelMap.has(requestKey)) {
      this.requestCancelMap.get(requestKey).next && this.requestCancelMap.get(requestKey).next();
      this.requestCancelMap.get(requestKey).complete && this.requestCancelMap.get(requestKey).complete();
      this.decrementRequestCount();
    }

    const cancelSubject = new Subject<void>();
    this.requestCancelMap.set(requestKey, cancelSubject);

    if (showLoader) this.activeRequestCount++; // Increment for this loader-enabled request

    return next.handle(updatedReq).pipe(
      takeUntil(cancelSubject),
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error: any) => {
            if (retryCount >= 3 || (error && error.status && error.status < 500)) {
              throw error;
            }
            return retryCount + 1;
          }, 0),
          delayWhen(retryCount => timer(Math.pow(2, retryCount) * 500))
        )
      ),
      tap((event) => {
        if (event instanceof HttpResponse) {
          if (updatedReq.url.indexOf('get_can_finance_status') !== -1 && (updatedReq.body && updatedReq.body.doctor_id)) {
            this.cache_data[updatedReq.body.doctor_id] = {
              timestamp: Date.now(),
              data: event.body
            };
          }
          this.requestCancelMap.delete(requestKey);
          if (showLoader) this.decrementRequestCount();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.requestCancelMap.delete(requestKey);
        if (showLoader) this.decrementRequestCount();
        return throwError(error);
      })
    );
  }

  private decrementRequestCount(): void {
    this.activeRequestCount--;
    if (this.activeRequestCount <= 0) {
      this.activeRequestCount = 0;
      this.hideLoader();
    }
  }

  private generateRequestKey(url: string, body: any): string {
    const base = url.split('?')[0];
    const sortedBody = body ? JSON.stringify(this.sortObjectKeys(body)) : '';
    return `${base}|${sortedBody}`;
  }

  private sortObjectKeys(obj: any): any {
    return Object.keys(obj || {}).sort().reduce((r, k) => (r[k] = obj[k], r), {});
  }

  private get isOnline(): boolean {
    return navigator.onLine;
  }

    private onEnd(): void {
    this.hideLoader();
  }

  private showLoader(): void {
    this.loaderService.show();
  }

  private hideLoader(): void {
    this.loaderService.hide();
  }

  private getUserProfile(): any {
    try {
      const raw = localStorage.getItem('userProfileData');
      const parsed = raw ? JSON.parse(raw) : null;
      return Array.isArray(parsed) ? parsed[0] : parsed;
    } catch (e) {
      return null;
    }
  }

  private getClck(): string[] | null {
    var decodedCookie = decodeURIComponent(document.cookie);
    var parts = decodedCookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf('_clck') !== -1) {
        return parts[i].split('=');
      }
    }
    return null;
  }
}
